import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { favoritesApi } from '../lib/api';

// Batch-fetches which of `contentIds` (all the same content_type) the current user has
// already favorited, once, for a listing page to seed its heart icons -- avoids one
// /favorites/check call per card. Returns a plain Set for O(1) `.has()` lookups; stays
// empty (no API call) for a logged-out viewer, since every heart starts unfavorited then.
export function useFavoritedIds(contentType, contentIds) {
  const { isAuthenticated } = useAuth();
  const [favoritedIds, setFavoritedIds] = useState(() => new Set());
  const key = (contentIds || []).join(',');

  useEffect(() => {
    if (!isAuthenticated || !key) {
      setFavoritedIds(new Set());
      return undefined;
    }
    let cancelled = false;
    favoritesApi
      .check(contentType, key.split(','))
      .then((ids) => {
        if (!cancelled) setFavoritedIds(new Set(ids));
      })
      .catch(() => {
        if (!cancelled) setFavoritedIds(new Set());
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, contentType, key]);

  return favoritedIds;
}
